import { IconProps } from "../../utils/global-types/global-types";

const ThreeDotsVerticalIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9 2.203a1.41 1.41 0 0 1 1.409 1.409A1.41 1.41 0 0 1 9 5.02a1.41 1.41 0 0 1-1.409-1.41 1.41 1.41 0 0 1 1.41-1.408M7.591 9a1.41 1.41 0 0 0 1.41 1.409A1.41 1.41 0 0 0 10.408 9 1.41 1.41 0 0 0 9 7.59 1.41 1.41 0 0 0 7.591 9m0 5.388a1.41 1.41 0 0 0 1.41 1.409 1.41 1.41 0 0 0 1.408-1.409A1.41 1.41 0 0 0 9 12.98a1.41 1.41 0 0 0-1.409 1.41"
      ></path>
    </svg>
  );
};

export default ThreeDotsVerticalIcon;
